<template>
  <header class="blog-header">
    <nav class="navbar navbar-expand-lg navbar-light bg-light logo-area">
      <main class="container">
        <a class="navbar-brand blog-header-logo" href="/">
          <img src="/images/logo-kementerian-keuangan-header@3x.jpg" alt="logo-kementerian-keuangan">
        </a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <nav class="navbar-nav nav ml-auto">
          <a class="nav-link" href="/" @click="GAEventTrack('menu', 'click-menu', 'informasi')">Informasi Program</a>
          <!-- <a class="nav-link" target="_blank" href="https://www.covid19.go.id/situasi-virus-corona/">Sebaran COVID-19</a> -->
          <a v-if="isLoggedIn" class="nav-link" href="/subsidi" @click="GAEventTrack('menu', 'click-menu', 'subsidi')">Subsidi</a>
          <a v-if="!isLoggedIn" @click="GAEventTrack('menu', 'click-menu', 'cek-subsidi')" class="btn btn-outline-primary" href="/masuk">Cek Subsidi</a>
          <a v-if="isLoggedIn" class="btn btn-outline-primary" href="#" @click="logout">Keluar</a>
        </nav>
        </div>
      </main>
    </nav>
  </header>
</template>

<style>

.navbar-light .navbar-nav .nav-link {
  color: #212529;
  font-weight: 600;
}

.navbar-light .navbar-nav .nav-link:hover {
  color: #003b74;
}

header .btn-outline-primary {
  color: #003b74;
  border-color: #003b74;
}

header .btn-outline-primary:hover {
  color: #fff;
  background: #003b74;
  border-color: #003b74;
}

header .navbar-light .navbar-toggler {
  border-color: transparent;
  color: #003b74;
}

.navbar-light .navbar-toggler-icon {
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(0, 59, 116, 1)' stroke-width='3' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E");
}

/* ----------------- RESPONSIVE STYLING ----------------- */
@media only screen and (max-width: 319px){
  header .navbar-expand-lg {
    padding-left: 15px;
    padding-right: 15px;
  }

  header .btn {
    margin-top: 20px;
  }

  header .navbar-nav.nav {
    padding-top: 20px;
  }
}
  
@media only screen and (min-width: 320px) and (max-width: 359px){
  header .navbar-expand-lg {
    padding-left: 15px;
    padding-right: 15px;
  }

  header .btn {
    margin-top: 20px;
  }

  header .navbar-nav.nav {
    padding-top: 20px;
  }
}
  
@media only screen and (min-width: 360px) and (max-width: 767px) {
  header .navbar-expand-lg {
    padding-left: 15px;
    padding-right: 15px;
  }

  header .btn {
    margin-top: 20px;
  }

  header .navbar-nav.nav {
    margin-top: 30px;
  }
}
  
@media only screen and (min-width: 768px) and (max-width: 799px) {
  header .navbar-expand-lg {
    padding-left: 15px;
    padding-right: 15px;
  }

  header .btn {
    margin-top: 20px;
  }

  header .navbar-nav.nav {
    padding-top: 20px;
  }
}
  
@media only screen and (min-width: 800px) and (max-width: 899px) {
  header .navbar-expand-lg {
    padding-left: 15px;
    padding-right: 15px;
  }

  header .btn {
    margin-top: 20px;
  }

  header .navbar-nav.nav {
    padding-top: 20px;
  }
}

@media only screen and (min-width: 900px) and (max-width: 1023px) {
  header .navbar-nav.nav {
    padding-top: 20px;
  }
}
  
@media only screen and (min-width: 1024px) and (max-width: 1259px) {
  header .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: 2rem;
    padding-left: 0px;
  }
}

@media only screen and (min-width: 1260px) and (max-width: 1280px) {
  header .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: 2rem;
    padding-left: 0px;
  }
}
  
@media only screen and (min-width: 1281px) and (max-width: 1699px) {
  header .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: 2rem;
    padding-left: 0px;
  }
}
  
@media only screen and (min-width: 1700px) {
  header .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: 2rem;
    padding-left: 0px;
  }
}

</style>

<script>
import EventTracking from '../services/eventTracking'

export default {
  mixins: [EventTracking],
  name: 'Header',
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    getUser() {
      return this.$store.getters.getUser;
    }
  },
  methods: {
    logout() {
      this.GAEventTrack('menu', 'click-menu', 'keluar')
      this.$store.dispatch('logout')
      .then(() => {
        this.$router.push('/');
      })
    }
  },
  mounted() {
    setInterval(() => { 
      let n = new Date()
      if ( n.getTime() > this.getUser.expire ) {
        this.logout()
      }
    }, (60000 * 10));
  }
};
</script>
